module.exports = require("@bios21/tstrait");